export default __webpack_public_path__ + "static/media/hall_of_fame_cup.7fa8463d.png";